export default "__VITE_ASSET__39892786__"